<template>
<v-container fill-height fluid>
  <v-row
    align="center"
    justify="center">
    <v-col>
      <h1 class="text-center mb-5">Welcome back to Pjili!</h1>

      <v-card
        class="mx-auto"
        max-width="400"
        outlined>

        <v-alert
          v-if="hasErrors()"
          color="warning">
          <ul>
            <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
          </ul>
        </v-alert>

        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="headline text-center mb-1">Horray, Set your new password.</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-card-text>
          <v-form @keyup.native.enter="finishRecovery()">
            <v-text-field
              @click:append="showPassword = !showPassword"
              v-model="Password"
              name="Password"
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              prepend-icon="mdi-key-outline" />
            <v-text-field
              @click:append="showPassword = !showPassword"
              v-model="PasswordConfirm"
              name="PasswordConfirm"
              label="Password confirm"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              prepend-icon="mdi-key-outline" />
          </v-form>

          <PasswordValidator v-on:passwordValidation="receiveValidation($event)" :Password="Password" :PasswordConfirm="PasswordConfirm" />

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="finishRecovery()"
            rounded
            :loading="loading" 
            color="info"
            :disabled="!passwordValid"
          >
            Next
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import PasswordValidator from "@/components/PasswordValidator.vue";

export default {
  name: "AccountRecoveryFinish",
  data() {
    return {
      Password: '',
      PasswordConfirm: '',
      passwordValid: false,
      loading: false,
      showPassword: false,
      errors: []
    }
  },
  components: {
    PasswordValidator
  },
  methods: {
    receiveValidation(pswValidation){
      if (pswValidation.valid){
        this.passwordValid = true
      } else {
        this.passwordValid = false
      }
    },
    finishRecovery() {
      this.loading = true
      this.$axios.post('/account-recovery/finish', {Id: this.$route.query.id, Password: this.Password, PasswordConfirm: this.PasswordConfirm})
        .then(() => {
          this.loading = false
          this.$store.dispatch("addNotification", {
            type: 'success',
            message: 'Nice! Your new password was saved, Please use your new password to login.'
          });
          this.errors = []
          this.$router.push({ name: 'login' })
        })
        .catch((error) => {
          if (!error.response) {
            this.errors = ['Network Error']
          } else if (error.response.data.errors) {
            this.errors = error.response.data.errors
          } else {
            this.errors = ['Unknown Error']
          }
          this.loading = false
        })
    },
    hasErrors() {
      return this.errors.length > 0
    }
  }
}
</script>